function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import h from "@macrostrat/hyper";
import Base from "mapbox-gl-controls/lib/Base/Base";
import Button from "mapbox-gl-controls/lib/Button/Button";
import { CompassControl as _CompassControl, ZoomControl as _ZoomControl } from "mapbox-gl-controls";
import { Icon } from "@blueprintjs/core";
import { useRef, useEffect, useState } from "react";
import classNames from "classnames";
import { useMapElement, useMapRef } from "./context";
export function MapControlWrapper(_ref) {
  var className = _ref.className,
      control = _ref.control,
      options = _ref.options;

  /** A wrapper for using Mapbox GL controls with a Mapbox GL map */
  var map = useMapRef();
  var controlContainer = useRef();
  var controlRef = useRef();
  useEffect(function () {
    if (map.current == null) return;
    var ctrl = new control(options);
    controlRef.current = ctrl;
    var controlElement = ctrl.onAdd(map.current);
    controlContainer.current.appendChild(controlElement);
    return function () {
      var _controlRef$current;

      (_controlRef$current = controlRef.current) === null || _controlRef$current === void 0 ? void 0 : _controlRef$current.onRemove();
    };
  }, [map.current, controlRef, controlContainer, options]);
  return h("div.map-control-wrapper", {
    className: className,
    ref: controlContainer
  });
}
export function GlobeControl(_ref2) {
  var className = _ref2.className;
  var map = useMapElement();

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      mapIsGlobe = _useState2[0],
      setIsGlobe = _useState2[1];

  useEffect(function () {
    // @ts-ignore
    var proj = map === null || map === void 0 ? void 0 : map.getProjection().name;
    setIsGlobe(proj == "globe");
  }, [map]);
  var nextProj = mapIsGlobe ? "mercator" : "globe";
  var icon = mapIsGlobe ? "map" : "globe";
  return h("div.map-control.globe-control.mapboxgl-ctrl-group.mapboxgl-ctrl.mapbox-control", {
    className: className
  }, [h("button.globe-control-button", {
    onClick: function onClick() {
      if (map == null) return; // @ts-ignore

      map.setProjection(nextProj);
      setIsGlobe(nextProj == "globe");
    }
  }, h(Icon, {
    icon: icon
  }))]);
} // Control for managing map 3D settings

var _ThreeDControl = /*#__PURE__*/function (_Base) {
  _inherits(_ThreeDControl, _Base);

  var _super = _createSuper(_ThreeDControl);

  /** A Mapbox GL control for entering 3D mode. */
  function _ThreeDControl() {
    var _this;

    _classCallCheck(this, _ThreeDControl);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "button", void 0);

    _this.button = new Button();
    return _this;
  }

  _createClass(_ThreeDControl, [{
    key: "insert",
    value: function insert() {
      var _this2 = this;

      this.addClassName("mapbox-3d");
      this.button.setText("3D");
      this.button.onClick(function () {
        _this2.map.easeTo({
          pitch: 60,
          duration: 1000
        });
      });
      this.addButton(this.button);
    }
  }, {
    key: "onAddControl",
    value: function onAddControl() {
      this.insert();
    }
  }]);

  return _ThreeDControl;
}(Base);

export var CompassControl = function CompassControl(_ref3) {
  var className = _ref3.className,
      options = _ref3.options;
  return h(MapControlWrapper, {
    className: classNames("compass-control", className),
    control: _CompassControl,
    options: options
  });
};
export var ZoomControl = function ZoomControl(_ref4) {
  var className = _ref4.className,
      options = _ref4.options;
  return h(MapControlWrapper, {
    className: classNames("zoom-control", className),
    control: _ZoomControl,
    options: options
  });
};
export var ThreeDControl = function ThreeDControl(_ref5) {
  var className = _ref5.className,
      options = _ref5.options;
  return h(MapControlWrapper, {
    className: classNames("map-3d-control", className),
    control: _ThreeDControl,
    options: options
  });
};